import { Box, Text } from '@factorialco/deprecated-design-system'
import { F0Card, F0Dialog } from '@factorialco/f0-react'

import i18n from 'modules/core/lib/i18n'

interface Props {
  onClose: () => void
  onSelectOption: (
    option: 'create-offer-letter-from-template' | 'send-offer-letter-from-scratch'
  ) => void
}

export const SendOfferLetterModal = ({ onClose, onSelectOption }: Props) => {
  return (
    <F0Dialog
      onClose={onClose}
      isOpen
      width="sm"
      title={i18n.t('ats.send_offer_letter_modal.title')}
    >
      <Text.Normal size="200">{i18n.t('ats.send_offer_letter_modal.selector.title')}</Text.Normal>
      <Box gap="s16" flexDirection="row" paddingTop="s16">
        <F0Card
          title={i18n.t('ats.send_offer_letter_modal.selector.from_scratch_title')}
          description={i18n.t('ats.send_offer_letter_modal.selector.from_scratch_description')}
          onClick={() => onSelectOption('send-offer-letter-from-scratch')}
        />
        <F0Card
          title={i18n.t('ats.send_offer_letter_modal.selector.from_template_title')}
          description={i18n.t('ats.send_offer_letter_modal.selector.from_template_description')}
          onClick={() => onSelectOption('create-offer-letter-from-template')}
        />
      </Box>
    </F0Dialog>
  )
}
